// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1.50015 7.91424L6.91436 2.50003L5.50015 1.08582L0.0859375 6.50003L1.50015 7.91424Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23.9144 6.50003L18.5002 1.08582L17.0859 2.50003L22.5002 7.91424L23.9144 6.50003Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12.0002 3.00003C6.4773 3.00003 2.00015 7.47718 2.00015 13C2.00015 18.5229 6.4773 23 12.0002 23C17.523 23 22.0002 18.5229 22.0002 13C22.0002 7.47718 17.523 3.00003 12.0002 3.00003ZM17 14H13V18H11V14H7V12H11V8H13V12H17V14Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-alarm-add-filled')
export default class AlarmAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'alarm-add-filled',
    }
  }
}
